<template>
  <a-row :gutter="[24, 24]">
    <a-col
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
      :md="{ span: 24 }"
      :xl="{ span: 20, offset: 2 }"
      :lg="{ span: 20, offset: 2 }"
    >
      <div>
        <a-card
          size="small"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px">
            Schematic of Perturbation-induced gene set enrichment analysis (
            PGSEA )
          </a>
          <div style="text-align: center; overflow-y: auto">
            <img
              src="http://research.gzsys.org.cn/perturbdb/image/PGSEA.png"
              width="1000"
              height="600"
            />
          </div>
        </a-card>
      </div>
      <div>
        <a-card
          size="small"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px">Workflow</a>
          <a-row>
            <a-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :xl="{ span: 12 }"
              :lg="{ span: 12 }"
              style="margin-top: 5px"
            >
              <div>
                <h1>
                  1. Select reference file:
                  <br />
                </h1>
                <a-radio-group
                  name="radioGroup"
                  :default-value="1"
                  v-model="bcfileValue"
                >
                  <a-radio :value="1" style="font-size: 16px">
                    Perturb-Seq
                  </a-radio>
                  <br />
                  <a-radio :value="2" style="font-size: 16px">
                    Bulk perturbation RNA-Seq</a-radio
                  >
                  <br />
                  <a-radio :value="3" style="font-size: 16px">
                    Perturb-Seq + Bulk perturbation RNA-Seq</a-radio
                  >
                </a-radio-group>
              </div>
              <br />
              <div>
                <h1>
                  2. Select method:
                  <br />
                </h1>
                <a-radio-group
                  name="radioGroup"
                  :default-value="1"
                  v-model="value"
                >
                  <a-radio :value="2" style="font-size: 16px">
                    Over-representation analysis (ORA)
                  </a-radio>
                  <br />
                  <a-radio :value="1" style="font-size: 16px">
                    Gene set enrichment analysis (GSEA)</a-radio
                  >
                </a-radio-group>
              </div>
              <br />
              <div style="margin-right: 5px">
                <h1>
                  3.1 Paste a gene set:
                  <!-- <a @click="changeCP">Example</a> -->
                  <a-button type="danger" shape="round" @click="changeCP">
                    <a-icon type="edit" /> example</a-button
                  >
                </h1>
                <!-- disabled="false" -->
                <a-textarea
                  :placeholder="dynamicPlaceholder"
                  :rows="6.5"
                  allow-clear
                  v-model="genelist"
                  @change="onChange"
                />
              </div>

              <div style="margin-top: 5px">
                <h1>
                  3.2 Or choose from a file:
                  <a-button type="danger" shape="round" @click="downloadFile()">
                    <a-icon type="cloud-download" /> example</a-button
                  >
                </h1>
                <!-- disabled="false" -->
                <a-upload-dragger
                  :key="uploadKey"
                  name="file"
                  action="http://research.gzsys.org.cn/perturbdb/data/upload/index.php"
                  method="POST"
                  :multiple="false"
                  :before-upload="beforeUploadFile"
                  :remove="removeFile"
                  @change="handleChange"
                  :disabled="this.uploaded"
                >
                  <!--     :file-list="fileList" -->
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <br />
                </a-upload-dragger>
              </div>
            </a-col>
            <a-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :xl="{ span: 12 }"
              :lg="{ span: 12 }"
              style="margin-top: 5px"
            >
              <a-card
                size="small"
                style="
                  border-radius: 5px;
                  border-color: green;
                  margin-left: 5px;
                "
                hoverable
                :headStyle="{ backgroundColor: 'green', borderRadius: '5px' }"
              >
                <a
                  slot="title"
                  class="guider"
                  style="font-size: 20px; color: white"
                >
                  4. Run
                </a>
                <a-card style="width: 100%">
                  <ul
                    style="
                      padding-left: 10px;
                      font-size: 16px;
                      line-height: 28px;
                      text-align: justify;
                    "
                  >
                    <li>
                      PGSEA utilizes user-provided gene lists to compare against
                      the comprehensive Perturb-Seq and bulk perturbation
                      RNA-Seq data curated within PerturbDB. This facilitates
                      the prediction of genes that exhibit similarities
                      following perturbation.
                    </li>
                    <li>
                      PGSEA now includes optional Pertub-Seq and Bulk
                      perturbation RNA-Seq data as reference files for
                      enrichment analysis.
                    </li>
                    <li>
                      PerturbDB now offers
                      <span style="color: red; font-weight: bolder"
                        >2 methods</span
                      >
                      to analyze user-specified lists of genes. The first method
                      is Over-Representation Analysis (ORA), the second method
                      is
                      <span style="color: red; font-weight: bolder"
                        >Gene Set Enrichment Analysis (GSEA)</span
                      >.
                    </li>
                    <li>
                      Upload by copying or pasting
                      <span style="color: orange; font-weight: bolder"
                        >a list of gene for ORA mode</span
                      >
                      , or
                      <span style="color: red; font-weight: bolder">
                        all ranked genes for GSEA mode</span
                      >, into textbox (3.1). Alternatively, you can upload from
                      a file (3.2).
                    </li>
                    <li>
                      Click 'Submit' to perform the calculation with default
                      settings.
                    </li>
                    <li>
                      Please do not leave this page while the analysis is in
                      progress.
                    </li>
                  </ul>
                </a-card>
                <br />
                <a-tooltip title="Click to reset the file upload list.">
                  <a-button
                    type="danger"
                    @click="resetUpload"
                    style="width: 100%; margin-bottom: 10px"
                    >Reset Upload</a-button
                  >
                </a-tooltip>
                <a-button
                  type="primary"
                  block
                  @click="startGPEA('#basic')"
                  :disabled="disabled"
                >
                  Submit
                </a-button>
              </a-card>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </a-col>
    <!-- result页面实现 -->
    <a-col
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
      :md="{ span: 24 }"
      :xl="{ span: 20, offset: 2 }"
      :lg="{ span: 20, offset: 2 }"
      v-show="this.nettrouble"
    >
      <a-card
        size="small"
        id="basic"
        style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
        hoverable
        :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
      >
        <a slot="title" class="guider" style="font-size: 20px">
          {{ this.methodMode }}
          result link of PGSEA
        </a>
        <span style="font-size: 20px">
          The result page URL is {{ this.resultlinks }}. To avoid potential
          delays due to network fluctuations, please save this URL. Enrichment
          results can typically be accessed from the following URL
          <span style="color: red">within five minutes</span> .
        </span>
      </a-card>
    </a-col>
    <a-col
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
      :md="{ span: 24 }"
      :xl="{ span: 20, offset: 2 }"
      :lg="{ span: 20, offset: 2 }"
      v-show="this.resultshow"
    >
      <a-spin
        :spinning="spinning"
        size="large"
        tip="PGSEA running, it usually takes 2 ~3 minutes to complete, please wait."
      >
        <a-card
          size="small"
          id="basic"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px">
            {{ this.methodMode }}
            result of PGSEA
          </a>
          <a-row v-show="this.resultCard" v-if="this.methodMode == 'ORA'">
            <a-col :span="10">
              <img height="100%" width="100%" :src="this.svgSrc" />
            </a-col>
            <a-col :span="14" style="padding-left: 10px"
              ><sctable
                v-bind:resultName="this.resultName"
                v-bind:methodN="this.value"
            /></a-col>
          </a-row>
          <a-row v-show="this.resultCard" v-if="this.methodMode == 'GSEA'">
            <a-col :span="24" style="padding-left: 10px">
              <!-- <a-alert message="Tips" type="info" show-icon>
                <div slot="description">
                  Gene set enrichment analysis guided by the following
                  principles:
                  <ul>
                    <li>
                      1. Gene set terms of
                      <span style="color: red">Up</span> and
                      <span style="color: blue">DN</span> from the same datasets
                      should both be included;
                    </li>
                    <li>
                      2. The NES for DN dataset is less than -1, and the p-value
                      must be less than 0.05;
                    </li>
                    <li>
                      3. If the NES value of the Up dataset is below 0 and the
                      p-value is less than 0.05, the downregulated dataset will
                      be excluded even if it meets the previous criterion. In
                      all other cases, the DN dataset will be retained as the
                      result;
                    </li>
                    <li>
                      4. PGSEA incorporates datasets of gene perturbations
                      involving knockdown or knockout, given the relative
                      scarcity of datasets involving activated gene edits;
                    </li>
                    <li>
                      5. By default, the results of PGSEA are sorted in
                      descending order based on the number of genes enriched in
                      the gene set (Size column).
                    </li>
                  </ul>
                </div>
              </a-alert> -->
              <gsea
                v-bind:resultName="this.resultName"
                v-bind:methodN="this.value"
            /></a-col>
          </a-row>
        </a-card>
      </a-spin>
    </a-col>
  </a-row>
</template>

<script>
import sctable from "../components/tools/scGPEA_table.vue";
import gsea from "../components/tools/scGPEA_GSEA.vue";
import axios from "axios";

export default {
  data() {
    return {
      //loading
      resultshow: false,
      spinning: true,
      resultCard: false,
      // input
      genelist: "",
      filename: "",
      //result
      resultName: "",
      svgSrc: "",
      // 方法标签
      value: 1,
      methodMode: "",
      nettrouble: false,
      resultlinks: "",
      // 文件标签
      bcfileValue: 1,
      // 任务提交
      // fileList: [],
      uploaded: false,
      uploadKey: 0, // 用于重新加载组件的key
      fileAllList: [],
      fileDrug: 0,
      disabled: true,
    };
  },
  computed: {
    dynamicPlaceholder() {
      if (this.value === 1) {
        return "Two columns, tab delimiter.";
      } else if (this.value === 2) {
        return "One column.";
      }
      return ""; // 如果value不是1或2，可以返回一个默认的placeholder或者空字符串
    },
  },
  watch: {
    fileAllList() {
      console.log(this.fileAllList);
    },
    value() {
      // 如果切换了模式输出卡片要先隐藏
      this.resultshow = false;
      this.resultCard = false;
      this.spinning = true;
      // genelist 和 filelist 都要清空
      this.genelist = "";
      if (this.value == 2) {
        this.$notification["success"]({
          message: "Using over-representation analysis (ORA)!",
          top: "100px",
          icon: <a-icon type="smile" style="color: #108ee9" />,
        });
      } else {
        this.$notification["success"]({
          message: "Using gene set enrichment analysis (GSEA)!",
          top: "100px",
          icon: <a-icon type="smile" style="color: #108ee9" />,
        });
      }
    },
    genelist() {
      //如果数据变了, 结果也要先隐藏
      this.resultshow = false;
      this.resultCard = false;
      this.spinning = true;
      if (this.genelist != "") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    fileDrug() {
      if (this.fileDrug == 1) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    bcfileValue() {
      // console.log(this.bcfileValue);
      if (this.bcfileValue == 1) {
        this.$notification["success"]({
          message: "Reference file of Perturb-seq selected!",
          top: "100px",
          // description: "Congratulations, result of PGSEA now are available!",
        });
      } else if (this.bcfileValue == 2) {
        this.$notification["success"]({
          message: "Reference file of Bulk perturbation experiments selected!",
          top: "100px",
          // description: "Congratulations, result of PGSEA now are available!",
        });
      } else {
        this.$notification["success"]({
          message:
            "Reference file of Perturb-seq + Bulk perturbation experiments selected!",
          top: "100px",
          // description: "Congratulations, result of PGSEA now are available!",
        });
      }
    },
  },
  components: { sctable, gsea },
  methods: {
    // 文件上传验证
    beforeUploadFile() {
      if (this.fileDrug) {
        this.$notification["warning"]({
          message:
            "Please upload only one file at a time for PGSEA analysis. Ensure to delete any previous files before proceeding!",
          top: "100px",
          duration: 10,
          // description: "Congratulations, result of PGSEA now are available!",
        });
        this.disabled = true;
      }
    },
    // 字符串输入验证:
    isValidTabDelimitedNumeric(str) {
      // 统一换行符，处理不同操作系统的差异
      str = str.replace(/\r\n/g, "\n");

      // 拆分字符串为行数组
      const lines = str.split("\n");

      // 正则表达式，验证一行中恰好有一个制表符，第二列为浮点数
      const validLineRegex = /^[^\t]+\t-?\d+(\.\d+)?$/;

      // 检查每一行是否都符合要求
      return lines.every((line) => validLineRegex.test(line));
    },
    // 删除文件
    removeFile(file) {
      // console.log("Removing file:", filelistO.findIndex());
      const fillListCheck = this.fileAllList;
      console.log(fillListCheck);
      const index = fillListCheck.findIndex(
        (fillListCheck) => fillListCheck.uid === file.uid
      );
      console.log(index);
      this.fileDrug -= 1;
      if (this.fileDrug == 0) {
        this.uploaded = false;
      }
      // // 示例：询问用户是否真的想移除文件
      // return new Promise((resolve, reject) => {
      //   this.$confirm({
      //     title: `Are you sure you want to remove ${file.name}?`,
      //     onOk() {
      //       console.log('File removed');
      //       resolve(true);
      //     },
      //     onCancel() {
      //       console.log('File remove cancelled');
      //       reject(false);
      //     }
      //   });
    },
    //拷贝实例:
    changeCP() {
      if (this.value == 2) {
        // ORA 方法实例数据
        this.genelist =
          "TAX1BP1\nIRF1\nSET\nPSMA3\nIFI35\nMEF2C\nMVP\nIER2\nPRTN3\nMAX\nGCC2\nHOXA9\nGIMAP4\nCD38\nHVCN1\nPHIP\nPPA1\nHMGB3\nSOWAHD\nENG\nGPX4\nKANK2\nOSBPL1A\nPARP14\nIDH2\nIL12RB1\nPSMB1\nPSAP\nPPP1CC\nUBB\nUHMK1\nCD1D\nISG20\nAKR1A1\nRNF19A\nRNASET2\nMYOF\nASAH1\nRGS16\nAPOC2\nFGR\nID1\nMAP3K7CL\nANXA4\nACTG1\nN4BP2L2\nZNFX1\nHM13\nGYPC\nNUPR1\nUBE2A\nRAB9A\nRCSD1\nMAT2B\nEXOC3L1\nRCN1\nSPN\nGPX1\nHLA-E\nAPOL1\nID2\nPRKAR2B\nFAM111A\nPAK1\nCTSO\nTMEM50B\nSENP6\nAPOBEC3G\nMBNL1\nHLA-F\nMOV10\nHSD17B11\nHLA-DQA1\nTCIRG1\nATOX1\nSLAMF7\nPLD3\nTYMP\nPSMB2\nACP5\nSDS\nIL6R\nCASP1\nZFP36L2\nC1orf162\nCD68\nOPTN\nGBP2\nGBP5\nCYBA\nRNF114\nCD47\nBAK1\nPYCARD\nSAMD9L";
      }
      if (this.value == 1) {
        // GSEA 方法实例数据
        this.genelist =
          "CCL8\t2.275657983\nCCL2\t1.976038397\nCXCL9\t1.956436477\nCCL7\t1.915040091\nCXCL10\t1.577030837\nC1QB\t1.361410312\nCCL4\t1.255765013\nC1QC\t1.108892791\nS100A10\t0.938314701\nCCL3\t0.879216588\nPDE4DIP\t0.788986334\nA2M\t0.766433981\nIL32\t0.750860249\nS100A12\t0.721209744\nIFI6\t0.718807286\nSTEAP4\t0.706628331\nPLEK\t0.682074413\nLINC01094\t0.664684453\nGK\t0.654101255\nIL1B\t0.627820512\nMARCKS\t0.615785002\nIGFBP3\t0.602232137\nHAPLN3\t0.586461839\nS100A8\t0.56947219\nRGCC\t0.563174627\nICAM1\t0.552317705\nVIM\t0.546394763\nCD44\t0.533968916\nS100A9\t0.52912653\nSERPINE2\t0.526223046\nCCL13\t0.52220409\nDEFB1\t0.521929309\nSLC12A8\t0.520306276\nTGFBI\t0.509896857\nTSC22D1\t0.488556095\nSMAP2\t0.484942163\nCDKN1A\t0.482316926\nRBPJ\t0.480256566\nHIF1A\t0.474283809\nAPOL4\t0.47089841\nGNG10\t0.467394856\nIFI16\t0.449519703\nMX1\t0.444273184\nDEK\t0.432070766\nCD83\t0.430658008\nISG15\t0.424434656\nRGS1\t0.420189622\nSERPING1\t0.420082924\nITGAV\t0.419585408\nG0S2\t0.41955085\nCYP1B1\t0.397644174\nDUSP6\t0.394843662\nCEBPB\t0.392176837\nCFH\t0.392162932\nCD14\t0.391487514\nPTPRC\t0.391156869\nHINT1\t0.390156282\nIL7R\t0.383676224\nMIR503HG\t0.381273985\nANKRD22\t0.374448305\nLY96\t0.365851861\nSNX20\t0.364032051\nTRIM22\t0.363062944\nLACC1\t0.360879974\nIFITM2\t0.356364198\nMX2\t0.352355689\nBTG2\t0.352301566\nIGFBP2\t0.345106488\nCCR1\t0.344799211\nPSTPIP2\t0.343076127\nFABP5\t0.341620859\nNAAA\t0.340359588\nSSB\t0.338694986\nFAM20A\t0.33779742\nTGFB1\t0.328854967\nBATF2\t0.325751078\nHIVEP3\t0.325481071\nUPP1\t0.323126449\nETHE1\t0.321187981\nGCLM\t0.320913548\nFCGR1A\t0.319867264\nHAVCR2\t0.319831378\nIL1RN\t0.31869946\nASAP1\t0.316187419\nYBX3\t0.315485579\nHEG1\t0.314571453\nMACF1\t0.313374864\nIDS\t0.310451083\nADCY3\t0.309293097\nLCP2\t0.30901571\nRGL1\t0.308871236\nCREM\t0.308821123\nSSBP4\t0.307607001\nGEM\t0.30715095\nCA11\t0.306762957\nSOD2\t0.304217282\nMAFB\t0.302464155\nSLC7A11\t0.297426018\nPLSCR1\t0.296942249\nGLUL\t0.293962956\nARL5A\t0.292660513\nMETTL7B\t0.290883723\nSGK1\t0.290022291\nPOU2F2\t0.286268358\nSMARCD3\t0.285229797\nPEA15\t0.283165603\nLPCAT2\t0.283116316\nTWIST1\t0.278953434\nCDK5RAP2\t0.277118669\nRHOBTB3\t0.274988663\nKCTD12\t0.273713204\nNUCB1\t0.273230714\nTBKBP1\t0.272399998\nZFP36L1\t0.271272426\nHMOX1\t0.271174369\nPNPT1\t0.270340612\nLACTB\t0.266681231\nNCOA7\t0.266200537\nGRINA\t0.264752368\nLGALS1\t0.264354693\nSPINT2\t0.264056069\nTPM1\t0.262855748\nTRIM25\t0.259540225\nCSF2RB\t0.257796503\nOSBPL8\t0.257509798\nCYBB\t0.256325513\nPPP1R15B\t0.256214911\nLRP12\t0.254089818\nFTH1\t0.253115051\nSOCS3\t0.252472535\nQKI\t0.252448344\nMIF\t0.251772092\nMTHFD2\t0.251522876\nANXA3\t0.250739719\nFCGR1B\t0.249524062\nTNFRSF1A\t0.248712183\nRALA\t0.247088892\nSLC2A1\t0.245384443\nITGA6\t0.244476452\nSORT1\t0.243594278\nLBH\t0.243173724\nTAGAP\t0.242148827\nDSC2\t0.241871625\nRALGDS\t0.241016089\nSTAMBPL1\t0.240860531\nRHOH\t0.239124078\nRELB\t0.238244257\nCLU\t0.238204845\nCTSC\t0.236614703\nCEBPE\t0.236311868\nTMEM123\t0.235541309\nSH2D2A\t0.234738245\nAPIP\t0.233030209\nRPS2\t0.231933783\nARID3A\t0.231246886\nIRF5\t0.229229172\nAK4\t0.226636935\nATP2B1\t0.226349965\nEIF2AK2\t0.226093652\nNKG7\t0.225755235\nTRIB1\t0.225135048\nSLC7A5\t0.224703538\nUSP18\t0.224650971\nRPL37A\t0.224387243\nCDC26\t0.223335062\nARRDC4\t0.222955081\nLGALS8\t0.222661149\nROBO1\t0.221318082\nGPR68\t0.219981066\nODC1\t0.219684866\nCCL20\t0.217858643\nANKRD28\t0.217619114\nORAI1\t0.217051599\nNMB\t0.215895353\nERI1\t0.215772284\nPLK3\t0.215638217\nMYC\t0.212328835\nNPDC1\t0.211067435\nALOX5AP\t0.210511664\nIFITM1\t0.209907201\nHMGN2\t0.209682979\nNCF2\t0.2085761\nTPST1\t0.207039654\nIFIT2\t0.207036898\nTPM4\t0.205427884\nSTAP1\t0.203276906\nSTXBP2\t0.202516586\nMRAS\t0.201987667\nRPL41\t0.200434536\nSEPHS2\t0.200295631\nAPP\t0.200220224\nTNFAIP6\t0.200024004\nIFIT1\t0.199235388\nYBX1\t0.198844882\nTRPS1\t0.19821671\nTBX21\t0.197718005\nSCNM1\t0.196819643\nTNFAIP8\t0.195983635\nEEF1B2\t0.195816507\nNCOA1\t0.195235765\nTAX1BP1\t-0.266695611\nIRF1\t-0.267699351\nSET\t-0.268849224\nPSMA3\t-0.269383605\nIFI35\t-0.269509868\nMEF2C\t-0.271838312\nMVP\t-0.272590089\nIER2\t-0.273521949\nPRTN3\t-0.274801873\nMAX\t-0.275162136\nGCC2\t-0.275306761\nHOXA9\t-0.276533985\nGIMAP4\t-0.276803518\nCD38\t-0.277241892\nHVCN1\t-0.277247803\nPHIP\t-0.278443821\nPPA1\t-0.27946074\nHMGB3\t-0.279758318\nSOWAHD\t-0.280419592\nENG\t-0.281020513\nGPX4\t-0.282530473\nKANK2\t-0.282608122\nOSBPL1A\t-0.282882704\nPARP14\t-0.282978078\nIDH2\t-0.28554289\nIL12RB1\t-0.286318148\nPSMB1\t-0.286607716\nPSAP\t-0.287658923\nPPP1CC\t-0.287957346\nUBB\t-0.287962862\nUHMK1\t-0.288533397\nCD1D\t-0.288944951\nISG20\t-0.289355262\nAKR1A1\t-0.289469338\nRNF19A\t-0.289482084\nRNASET2\t-0.291298694\nMYOF\t-0.291484714\nASAH1\t-0.291705141\nRGS16\t-0.292464113\nAPOC2\t-0.292754726\nFGR\t-0.292828241\nID1\t-0.294001011\nMAP3K7CL\t-0.295327768\nANXA4\t-0.295506167\nACTG1\t-0.297673204\nN4BP2L2\t-0.29879256\nZNFX1\t-0.30019251\nHM13\t-0.300585034\nGYPC\t-0.308811366\nNUPR1\t-0.310447684\nUBE2A\t-0.312155958\nRAB9A\t-0.314347156\nRCSD1\t-0.314728803\nMAT2B\t-0.315972437\nEXOC3L1\t-0.316031206\nRCN1\t-0.31650464\nSPN\t-0.317873787\nGPX1\t-0.317914886\nHLA-E\t-0.318236037\nAPOL1\t-0.319333063\nID2\t-0.320202429\nPRKAR2B\t-0.322929012\nFAM111A\t-0.322998169\nPAK1\t-0.324845666\nCTSO\t-0.325298508\nTMEM50B\t-0.325382774\nSENP6\t-0.326240055\nAPOBEC3G\t-0.327555997\nMBNL1\t-0.329368952\nHLA-F\t-0.329971407\nMOV10\t-0.332713465\nHSD17B11\t-0.335195467\nHLA-DQA1\t-0.335270238\nTCIRG1\t-0.34163258\nATOX1\t-0.346617482\nSLAMF7\t-0.346693232\nPLD3\t-0.34737926\nTYMP\t-0.348837417\nPSMB2\t-0.352706183\nACP5\t-0.355640654\nSDS\t-0.356616037\nIL6R\t-0.358526864\nCASP1\t-0.361513644\nZFP36L2\t-0.362037499\nC1orf162\t-0.36446792\nCD68\t-0.367173183\nOPTN\t-0.367933516\nGBP2\t-0.368377469\nGBP5\t-0.375923139\nCYBA\t-0.376285878\nRNF114\t-0.37633008\nCD47\t-0.380064464\nBAK1\t-0.380724171\nPYCARD\t-0.380975615\nSAMD9L\t-0.381014937\nFGD2\t-0.381549369\nEIF1AY\t-0.3819731\nMT2A\t-0.385666747\nDNASE2\t-0.386130245\nFCGRT\t-0.388405123\nCDKN2C\t-0.389361141\nTMSB10\t-0.390196267\nRMDN3\t-0.390268021\nAZU1\t-0.390530656\nDNPEP\t-0.390756516\nTKTL1\t-0.392964913\nTXNIP\t-0.393962477\nANXA1\t-0.394528044\nGRN\t-0.395775663\nAPOL3\t-0.398613005\nTAP1\t-0.401296796\nKIAA0040\t-0.40329198\nCASP4\t-0.404270974\nCD36\t-0.405251125\nRSU1\t-0.405520518\nCITED2\t-0.40881136\nHLA-DMB\t-0.411096242\nDNAJA1\t-0.415422731\nLGALS3BP\t-0.416386844\nTYROBP\t-0.417909888\nBTG1\t-0.422304026\nIGFBP4\t-0.422652078\nB2M\t-0.428066701\nCD52\t-0.431063463\nRAB24\t-0.435363763\nLST1\t-0.435636829\nGM2A\t-0.437839728\nSRGN\t-0.440182624\nTXN\t-0.440250139\nGCHFR\t-0.441771017\nPDIA3\t-0.454773305\nPSMA5\t-0.45651176\nATP1B1\t-0.459269793\nPSMA4\t-0.461697989\nPOMP\t-0.466939843\nGLRX\t-0.469904488\nIFI30\t-0.476211671\nGBP3\t-0.477616695\nCALCOCO2\t-0.478896017\nCD40\t-0.482434871\nPSMB9\t-0.490743261\nC5orf15\t-0.491095626\nCTSB\t-0.506458093\nSLC44A1\t-0.508991328\nUSP30-AS1\t-0.509094667\nCASP8\t-0.523813304\nRNF213\t-0.525502341\nOGFR\t-0.526805804\nTGM2\t-0.533059455\nGLIPR1\t-0.533212879\nDECR1\t-0.544854108\nTNFSF10\t-0.550464621\nTMEM179B\t-0.550473292\nAPOE\t-0.551807185\nBAZ1A\t-0.55343553\nCHI3L1\t-0.555696402\nSCARB2\t-0.562285543\nITGB7\t-0.568827651\nCARD16\t-0.575262496\nHLA-B\t-0.59118291\nSTX11\t-0.595963976\nITM2B\t-0.603750502\nOLFML3\t-0.613278093\nSCPEP1\t-0.615313069\nETV7\t-0.636752179\nQPRT\t-0.65141704\nGSDMD\t-0.654356506\nCTSD\t-0.663305072\nTAPBP\t-0.669003388\nIDO1\t-0.674460629\nIL15RA\t-0.677021937\nNUB1\t-0.678602095\nDYNLT1\t-0.702365396\nHLA-C\t-0.710999679\nCTSS\t-0.714758806\nHLA-DRB1\t-0.734549951\nGUK1\t-0.737400976\nHLA-DQB1\t-0.737412443\nHLA-DRB5\t-0.7569362\nHLA-DPB1\t-0.773585547\nTNFRSF14\t-0.777253847\nHLA-DMA\t-0.797054573\nHLA-A\t-0.832174077\nHMGN3\t-0.844747387\nCD70\t-0.870264105\nAPOC1\t-0.900913316\nJAK2\t-0.90775092\nGCH1\t-0.911157205\nSOCS1\t-0.922650367\nGBP1\t-1.044762277\nHLA-DPA1\t-1.05404571\nHLA-DRA\t-1.076550391\nCD74\t-1.246990745\nPSMB10\t-1.267795521\nIL18BP\t-1.274213591\nGBP4\t-1.346105704\nNCF1\t-1.526768473\nPSME1\t-1.55057928\nPSME2\t-1.810539413";
      }
    },
    //下载实例
    //下载文件
    downloadFile() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接
      if (this.value == 2) {
        link.href =
          "http://research.gzsys.org.cn/perturbdb/data/upload/demo/test-METTL3-ORAmode.txt";

        link.setAttribute(
          "download",
          "PGSEA_METTL3_perturbation.formENCODE.ORA.txt"
        );
      }
      if (this.value == 1) {
        link.href =
          "http://research.gzsys.org.cn/perturbdb/data/upload/demo/test-METTL3-GSEAmode.txt";

        link.setAttribute(
          "download",
          "PGSEA_METTL3_perturbation.formENCODE.GSEA.txt"
        );
      }
      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    //开始计算
    startGPEA() {
      // 生成时间戳
      const timestamp = new Date().getTime();
      // 将时间戳转换为字符串
      const timestampString = timestamp.toString();

      if (this.value == 1) {
        this.methodMode = "GSEA";
      } else {
        this.methodMode = "ORA";
      }

      //开始绘制图片,计算
      if (this.genelist != "") {
        // 如果不符合就结束
        console.log(this.genelist);
        console.log(this.isValidTabDelimitedNumeric(this.genelist));
        if (
          this.value == 1 &&
          !this.isValidTabDelimitedNumeric(this.genelist)
        ) {
          this.$notification["warning"]({
            message:
              "The data format you've entered does not align with the requirements for GSEA analysis. Please ensure the data consists of two columns, separated by tabs, with the second column containing only numerical values. Kindly verify your data and try again.",
            top: "100px",
            style: {
              width: "600px",
              marginLeft: `${400 - 600}px`,
              textAlign: "justify",
            },
            duration: 20,
            icon: (
              <a-icon type="alert" theme="twoTone" two-tone-color="#eb2f96" />
            ),
            // description: "Congratulations, result of PGSEA now are available!",
          });
          this.disabled = true;
          this.genelist = "";
          return false;
        }
        // 任务提交提示
        this.$notification.open({
          message: "Mission start!",
          top: "100px",
          description:
            " Please do not leave this page while the analysis is in progress",
          icon: <a-icon type="smile" style="color: #108ee9" />,
        });
        // 结果展示
        this.resultshow = true;
        this.disabled = true;
        // 结果计算
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/tools/scGPEAcpMode.php",
            {
              timeout: 0,
              params: {
                genelist: this.genelist.replace(/\n/g, ",").replace(/\t/g, "_"),
                timeStamp: timestampString,
                methodN: this.methodMode,
                bcfileValue: this.bcfileValue,
              },
            }
          )
          .then((response) => {
            if (response.data != "failed") {
              this.$notification["success"]({
                message: "Job done!",
                top: "100px",
                description:
                  "Congratulations, result of PGSEA now are available!",
              });
              this.svgSrc =
                "http://research.gzsys.org.cn/perturbdb/data/upload/temp/scGPEA_" +
                timestampString +
                ".svg";
              this.resultName = "scGPEA_" + timestampString;
              this.spinning = false;
              this.resultCard = true;
              // // 获取页面底部元素的引用
              // const bottomElement = document.querySelector("#bottom");

              // // 将页面滚动到底部
              // bottomElement.scrollIntoView({ behavior: "smooth" });
            } else {
              this.$message.error("Please check your input genes!", 6);
            }
          })
          .catch((error) => {
            // 处理超时或其他错误
            console.log(error);
            // 不展示结果cards
            this.resultshow = false;
            this.spinning = false;
            this.nettrouble = true;
            this.resultlinks = "scGPEA_" + timestampString;
          });
      }

      if (this.genelist == "") {
        this.resultshow = true;
        axios
          .get("http://research.gzsys.org.cn/perturbdb/API/tools/scGPEA.php", {
            timeout: 0,
            params: {
              filename: this.filename,
              timeStamp: timestampString,
              methodN: this.methodMode,
              bcfileValue: this.bcfileValue,
            },
          })
          .then((response) => {
            console.log(response.data);
            if (response.data != "failed") {
              this.$notification["success"]({
                message: "Job done!",
                top: "100px",
                description:
                  "Congratulations, result of PGSEA now are available!",
              });
              this.svgSrc =
                "http://research.gzsys.org.cn/perturbdb/data/upload/temp/scGPEA_" +
                timestampString +
                ".svg";
              this.resultName = "scGPEA_" + timestampString;
              this.spinning = false;
              this.resultCard = true;
              this.disabled = true;
              // // 获取页面底部元素的引用
              // const bottomElement = document.querySelector("#bottom");

              // // 将页面滚动到底部
              // bottomElement.scrollIntoView({ behavior: "smooth" });
            } else {
              this.$message.error("Please check your input genes!", 6);
            }
          })
          .catch((error) => {
            // 处理超时或其他错误
            console.log(error);
            // 不展示结果cards
            this.resultshow = false;
            this.spinning = false;
            this.nettrouble = true;
            this.resultlinks = "scGPEA_" + timestampString;
          });
      }
    },
    onChange(e) {
      console.log(e);
    },
    resetUpload() {
      this.uploaded = false; // 解除禁用状态
      this.fileDrug = 0;
      this.uploadKey++; // 改变key，触发组件重新加载
    },
    handleChange(info) {
      const status = info.file.status;
      this.filename = info.file.name;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.genelist = "";
        this.fileDrug += 1;
        this.uploaded = true;
        this.fileAllList.push(info.file);
        if (this.fileDrug == 1) {
          this.$notification["success"]({
            message: this.filename + " upload successfully.",
            top: "100px",
            // description: "Congratulations, result of PGSEA now are available!",
          });
        }
        console.log(this.fileDrug);
      } else if (status === "error") {
        this.genelist = "";
        this.$notification["error"]({
          message: this.filename + " file upload failed.",
          top: "100px",
          // description: "Congratulations, result of PGSEA now are available!",
        });
      }
    },
  },
};
</script>

<style>
a-textarea {
  height: 200px; /* 设置默认高度为 200 像素 */
}
</style>
